module.exports = __webpack_public_path__ + "img/logo.72aa7837.svg";